// Countries unavailable for checkout under the store's trade policy.
export const RESTRICTED_COUNTRY_CODES = [
  "AF",
  "BY",
  "CU",
  "IR",
  "KP",
  "RU",
  "SY",
];

export const RESTRICTED_PHONE_COUNTRIES = RESTRICTED_COUNTRY_CODES;

export const RESTRICTION_MESSAGE =
  "This destination is currently unavailable for checkout.";

export const isRestrictedCountry = (countryCode) =>
  RESTRICTED_COUNTRY_CODES.includes(String(countryCode || "").toUpperCase());
